/**
 * Course vocabulary shared by the schema, the admin forms and the coach pages.
 *
 * Aliases: course status, course materials, business builder course
 */

/** Draft courses are admin-only; published ones show to coaches. */
export const COURSE_STATUSES = ["draft", "published"] as const;
export type CourseStatus = (typeof COURSE_STATUSES)[number];

/**
 * What a week hands out beside its class. Slides and templates are links (a
 * PDF, a Google Doc); a replay is a video from the library.
 */
export const COURSE_MATERIAL_KINDS = ["slides", "template", "replay"] as const;
export type CourseMaterialKind = (typeof COURSE_MATERIAL_KINDS)[number];

export const COURSE_MATERIAL_KIND_LABELS: Record<CourseMaterialKind, string> = {
  slides: "Slides",
  template: "Template",
  replay: "Office hours",
};

/** The line under a material's title when the admin left the note empty. */
export const COURSE_MATERIAL_DEFAULT_NOTES: Record<CourseMaterialKind, string> =
  {
    slides: "Slide deck",
    template: "Editable · fill it in as you go",
    replay: "Recorded live · questions from other coaches",
  };
